import { ApiFactory } from '../factories/api.factory';

export class TimeframesApi extends ApiFactory { }
